import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmarDialogComponent } from 'src/app/shared/components/confirmar-dialog/confirmar-dialog.component';
import { NativeBridgeService } from './native-bridge.service';
import { deviceMessageId } from '../enums/device-message-id.enum';
import { PopupService } from './popup.service';
import { reloadPage } from 'src/assets/js/reload';
@Injectable({
  providedIn: 'root'
})
export class CacheControlService {
  dialogConfirm: MatDialogRef<ConfirmarDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private nativeService: NativeBridgeService,
    private popUpService: PopupService
  ) {}

  showDialog(popId: string) {
    if (!this.popUpService.isPopupOpen(popId)) {
      this.dialogConfirm = this.dialog.open(ConfirmarDialogComponent, {
        data: {
          info: 'Atención',
          title: 'Existe una nueva versión disponible',
          button: 'Actualizar',
          hideCancelButton: true,
          disableClose: true
        }
      });
      this.popUpService.addPopup(popId);
      this.dialogConfirm.afterClosed().subscribe((data) => {
        if (data) {
          if (localStorage.getItem('appEnvironment')) {
            const messageToSend: QrMessageToDevice = {
              message_id: deviceMessageId.INVALIDATE_CACHE
            };
            this.nativeService.sendMessageToDevice(JSON.stringify(messageToSend));
            this.popUpService.removePopup(popId);
          } else {
            this.popUpService.removePopup(popId);
            reloadPage();
            setTimeout(() => {
              reloadPage();
            }, 450);
          }
        }
      });
    }
  }
}

interface QrMessageToDevice {
  message_id: string;
}
